/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from "react";
import styled from "@emotion/styled";
import { colors, Title1 } from "@utils/ui_palette";
import { rgba } from "emotion-rgba";

interface IModule {
  id: number;
  question: string;
  anwser: string;
  choice: string[] | null;
  question_image: null | string;
  score: number;
  answer_submit: string;
  answer_s3: string;
  answer_id: string;
}

interface IModal {
  item: IModule | null;
  type: string | null;
  callback: (item: IModule, type: string, answer: string | number) => void;
  handleModal: (state: boolean) => void;
}

function ImageModal({ item, type, callback, handleModal }: IModal) {
  const closeModal = useCallback(() => {
    handleModal(false);
  }, []);

  const handleSubmit = useCallback(() => {
    if (item && type) {
      closeModal();
      callback(item, type, item.anwser);
    }
  }, []);

  return (
    <Modals>
      <ModalBody>
        {item && type && (
          <>
            <Title1>{type}</Title1>
            <Contents>
              <Question>
                {type === "Uppercase" ||
                type === "Lowercase" ||
                type === "Write_1_to_10" ||
                type === "Write_1_to_20" ||
                type === "Write_1_to_30" ? (
                  item.question
                ) : (
                  <Image src={item.question} />
                )}
              </Question>

              <ContentsBox>
                {item.answer_s3 === "" ? (
                  <Title1>{item.answer_submit}</Title1>
                ) : (
                  <>
                    {type === "Shapes" ? (
                      <Audio src={item.answer_s3} controls />
                    ) : (
                      <Image src={item.answer_s3} />
                    )}
                  </>
                )}
              </ContentsBox>
            </Contents>
          </>
        )}
        {item && type && (
          <ButtonGroup>
            <ConfirmButton
              onClick={handleSubmit}
              active={
                item.anwser.toLowerCase() === item.answer_submit.toLowerCase()
              }
              disabled={
                item.anwser.toLowerCase() === item.answer_submit.toLowerCase()
              }
            >
              정답처리
            </ConfirmButton>
            <CancelButton onClick={closeModal}>취소</CancelButton>
          </ButtonGroup>
        )}
      </ModalBody>
    </Modals>
  );
}

const Modals = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: ${rgba(colors.Black, 0.5)};
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBody = styled.div`
  width: 900px;
  padding: 30px;
  background-color: ${colors.White};
  border-radius: 15px;
`;

const Contents = styled.div``;

const Image = styled("img")`
  height: 200px;
`;

const Audio = styled("audio")`
  width: 100%;
`;

const ContentsBox = styled.div`
  flex-basis: calc(50% - 20px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Question = styled.div`
  padding: 20px;
  font-size: 36px;
  border: 1px solid ${colors.Black};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px auto;
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 80px;
`;

const ConfirmButton = styled.button<{ active: boolean }>`
  flex-basis: calc(50% - 10px);
  height: 50px;
  outline: 0;
  border: 0;
  background-color: ${(props) =>
    props.active ? colors.Gray30 : colors.Primary50};
  border-radius: 8px;
  color: ${colors.White};
  cursor: ${(props) => (props.active ? "not-allowed" : "pointer")};
`;

const CancelButton = styled.button`
  flex-basis: calc(50% - 10px);
  height: 50px;
  outline: 0;
  border: 1px solid ${colors.Black};
  background-color: ${colors.White};
  border-radius: 8px;
  color: ${colors.Black};
  cursor: pointer;
`;

export default ImageModal;
